var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 14",
    id: "Mail-Send-Envelope--Streamline-Core.svg",
    height: 14,
    width: 14,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Mail Send Envelope Streamline Icon: https://streamlinehq.com")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mail-send-envelope--envelope-email-message-unopened-sealed-close"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M12.5 1.75h-11c-0.552285 0 -1 0.44772 -1 1v8.5c0 0.5523 0.447715 1 1 1h11c0.5523 0 1 -0.4477 1 -1v-8.5c0 -0.55228 -0.4477 -1 -1 -1Z",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    stroke: "#ffffff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m0.5 3 5.86 3.52424c0.17969 0.10549 0.40615 0.16326 0.64 0.16326s0.46031 -0.05777 0.64 -0.16326L13.5 3",
    strokeWidth: 1
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuMessages);
export default __webpack_public_path__ + "static/media/menu-messages.159d140d42d794e7ea6d2f1f9b0b5a76.svg";
export { ForwardRef as ReactComponent };